import { render, staticRenderFns } from "./TabelaDadosFiscaisTributariosPf.vue?vue&type=template&id=71c15f5b&lang=pug"
import script from "./TabelaDadosFiscaisTributariosPf.vue?vue&type=script&lang=js"
export * from "./TabelaDadosFiscaisTributariosPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaDadosFiscaisTributariosPf.vue?vue&type=style&index=0&id=71c15f5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports